var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddMemberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9247 32.6032H1.54004V31.2132C1.56045 29.2589 2.07588 27.3414 3.03817 25.6404C4.00048 23.9392 5.37824 22.5097 7.04278 21.4853C8.70735 20.461 10.6044 19.8752 12.5567 19.7828C14.509 19.6904 16.4528 20.0943 18.2067 20.9568M27.1811 19.7827V35.1673M19.4888 27.475H34.8734M13.0785 14.6545C16.6188 14.6545 19.4888 11.7845 19.4888 8.24424C19.4888 4.70396 16.6188 1.83398 13.0785 1.83398C9.53825 1.83398 6.66827 4.70396 6.66827 8.24424C6.66827 11.7845 9.53825 14.6545 13.0785 14.6545Z",
    stroke: "#0E9349",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMemberIcon);
export default __webpack_public_path__ + "static/media/addMemberIcon.8f3842d3d7ff6e80e916072c388ba48b.svg";
export { ForwardRef as ReactComponent };